import { store } from '@/Infrastructure/State';

import type { IActionObject } from '../user/user.actions';

import { SET_CUSTOMER_SWITCHES } from './switches.actions';

const switchesReducer = (state = {}, action: IActionObject<unknown>) => {
  switch (action.type) {
    case SET_CUSTOMER_SWITCHES:
      return action.payload ? { ...state, ...action.payload } : state;
    default:
      return state;
  }
};

export const getCurrentSwitches = () => {
  if (store?.getState()?.switches) {
    return store?.getState()?.switches;
  }
};

export default switchesReducer;
